import {Link} from 'react-router-dom';

import PageContainer from 'src/components/PageContainer';
import PageTitle from 'src/components/PageTitle';
import {useTranslations} from 'src/components/TranslationsContext';
import {LoggedInAuth, useCurrentOrganization} from 'src/hooks/useAuth';
import {useCurrentOrgIdPrefix} from 'src/hooks/useCurrentOrgIdPrefix';
import {ApiUserProfile} from 'src/lib/api/auth';
import featureFlags from 'src/lib/featureFlags';
import * as tw from 'src/lib/tailwindClasses';

type Props = {
  currentUser: ApiUserProfile;
  auth: LoggedInAuth;
};

export default function Settings({currentUser, auth}: Props) {
  const {t} = useTranslations();
  const currentOrgUuidPrefix = useCurrentOrgIdPrefix();
  const currentOrg = useCurrentOrganization()!;

  const userBelongsToOrg = currentUser.organizations.some((o) => o.id === currentOrg.id);

  return (
    <PageContainer>
      <PageTitle
        pageStack={[
          {title: currentOrg.name, to: '/:currentOrgIdPrefix/projects'},
          {title: t('settings'), to: `/:currentOrgIdPrefix/settings`},
        ]}
      />
      <ul>
        <div>
          <li>
            {!userBelongsToOrg ? (
              <span
                className={`cursor-not-allowed opacity-50`}
                title={t('profileNotInProfileOrg', {
                  profileOrgName: auth.profileOrganizations[0].name,
                })}
              >
                {t('profile')}
              </span>
            ) : (
              <Link
                to={`/${currentOrgUuidPrefix}/settings/users/${currentUser.id}`}
                className={`${tw.link}`}
              >
                {t('profile')}
              </Link>
            )}
          </li>
        </div>
        <li>
          <Link to={`/${currentOrgUuidPrefix}/settings/users`} className={`${tw.link}`}>
            {t('team')}
          </Link>
        </li>
        <li>
          <Link to={`/${currentOrgUuidPrefix}/settings/organization`} className={`${tw.link}`}>
            {t('organization')}
          </Link>
        </li>
        <li>
          <Link to={`/${currentOrgUuidPrefix}/settings/notifications`} className={`${tw.link}`}>
            {t('notificationsAndAlerts')}
          </Link>
        </li>

        {['owner', 'admin', 'regular'].includes(currentUser.role) && (
          <li>
            <Link to={`/${currentOrgUuidPrefix}/settings/api`} className={`${tw.link}`}>
              {t('api')}
            </Link>
          </li>
        )}
        {['owner', 'admin', 'regular'].includes(currentUser.role) &&
          featureFlags.OBSERVATIONS_UPLOAD(currentUser) && (
            <li>
              <Link to={`/${currentOrgUuidPrefix}/settings/observations`} className={`${tw.link}`}>
                {t('observations')}
              </Link>
            </li>
          )}
      </ul>
    </PageContainer>
  );
}
